import o from"./accordionHighlighted.module.scss.js";import s from"./index.module.scss.js";const c=s;const i=o;export{i as AccordionHighlightedTheme,c as AccordionTheme};
//# sourceMappingURL=index.js.map
